// extracted by mini-css-extract-plugin
export var wordContainer = "_pt-0";